import { render, staticRenderFns } from "./y_detail.vue?vue&type=template&id=5bde8f0c&"
import script from "./y_detail.vue?vue&type=script&lang=js&"
export * from "./y_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports